<template>
  <th v-if="isHeader">
    <!-- Table Header actions -->
    Actions
  </th>
  <td v-else>
    <!-- Table Body - Row actions -->
    <div v-if="$route.meta.isAdmin" class="ta-center">
      <base-button @click="onClickEdit">Edit</base-button>
    </div>
    <div v-else class="ta-center">
      <base-button @click="onClickJoin" v-if="!userInGroup" :primary="true"
        >Join</base-button
      >
      <base-button @click="onClickLeave" v-else danger>Leave</base-button>
    </div>
  </td>
</template>

<script>
import Dropdown from "./Dropdown";
import DropdownAction from "./DropdownAction";

import VuetableFieldMixin from "vuetable-2/src/components/VuetableFieldMixin";
import UserHasPermission from "@/mixins/UserHasPermission";
import { mapGetters } from "vuex";

export default {
  name: "GroupActions",
  data() {
    return {
      localGroups: [],
    };
  },

  methods: {
    refreshGroups() {
      this.localGroups = JSON.parse(
        localStorage.getItem("mft_groups_getUserInterestGroups")
      ).groupIds;
      // when we update the groups, we then need to clear dashboard data so that content will refresh
      const keys = [
        "USER_DASHBOARD",
        "USER_DASHBOARD_TTL",
        "ADMIN_USER_DASHBOARD",
        "ADMIN_USER_DASHBOARD_TTL",
      ];
      keys.forEach((key) => {
        localStorage.removeItem(key);
      });
    },
    async onClickJoin() {
      await this.$store.dispatch("InterestGroups/join", this.rowData.id);
      await this.$store.dispatch("InterestGroups/getUserInterestGroups", true);
      this.refreshGroups();
      this.$store.dispatch(
        "notifications/create",
        {
          body: `You have joined the group`,
          type: "success",
        },
        { root: true }
      );
    },

    async onClickLeave() {
      await this.$store.dispatch("InterestGroups/leave", this.rowData.id);
      await this.$store.dispatch("InterestGroups/getUserInterestGroups", true);
      this.refreshGroups();
      this.$store.dispatch(
        "notifications/create",
        {
          body: `You have left the group`,
          type: "success",
        },
        { root: true }
      );
    },

    onClickView() {
      this.$router.push(`/content${this.rowData.page_url}`);
    },

    onClickEdit() {
      this.$router.push({
        name: "GroupEdit",
        params: { groupId: this.rowData.id },
      });
    },

    onClickDuplicate() {
      this.$router.push(
        `/admin/content/pages/create?duplicate=${this.rowData.id}`
      );
    },

    onClickDelete() {
      this.$store.dispatch("createDialog", {
        confirm: () => {
          this.$store
            .dispatch("pages/delete", this.rowData.id)
            .then((response) => {});
        },
      });
    },
  },

  computed: {
    userCanAdd() {
      return this.userHasPermission("add_edit_pages");
    },
    userCanApprove() {
      return this.userHasPermission("approve_pages");
    },
    userInGroup() {
      if (!this.localGroups || this.localGroups.length < 1) {
        return false;
      }
      //groups should now be in localStorage
      const matched = this.localGroups.filter((id) => id === this.rowData.id);

      return matched.length > 0;
    },
  },

  created() {
    this.refreshGroups();
  },

  components: {
    Dropdown,
    DropdownAction,
  },

  mixins: [VuetableFieldMixin, UserHasPermission],
};
</script>
